<template>
  <div class="new-record">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Add New Website Account ( ID: {{ parseInt(counter) + 1 }} )</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="company" :rules="nameRules" label="Company Name (*)" required></v-text-field>

                <v-text-field v-model="domain" :rules="nameRules" label="domain URL (*)" required></v-text-field>

                <v-text-field v-model="username" :rules="nameRules" label="Username (*)" required></v-text-field>

                <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="Password (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

                <v-text-field v-model="userLevel" :rules="nameRules" label="User Level (*)" required></v-text-field>

                <v-text-field v-model="takeFrom" :rules="nameRules" label="Take From (*)" required></v-text-field>

                <v-text-field v-model="contact" label="Contact (optional)" required></v-text-field>

                <v-text-field v-model="positionSharing" :rules="nameRules" label="Position Sharing (*)" required></v-text-field>

                <v-textarea v-model="remark" outlined label="Remark (Optional)"></v-textarea>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('dialogHide')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="$store.state.snackSuccess" :disabled="!valid" @click="saveRecord">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  props: [ 'dialog', 'Type', 'counter' ],

  data: () => ({
    
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      date: new Date().toISOString().substr(0, 10),
      modal: false,

      company: '',
      domain: '',
      username: '',
      password: '',
      userLevel: '',
      takeFrom: '',
      contact: '',
      positionSharing: '',
      remark: '',

  }),

  methods: {

    saveRecord() {

      this.$store.dispatch('storeWebsite', {
        company: this.company,
        domain: this.domain,
        username: this.username,
        password: this.password,
        user_level: this.userLevel,
        take_from: this.takeFrom,
        contact: this.contact,
        position_sharing: this.positionSharing,
        remark: this.remark,
        counter: parseInt(this.counter) 
      })
      .then(() => { this.$emit('dialogHide') });

    }

  },

}
</script>

<style>

</style>